<footer class="bg-gray-100 border-t border-gray-200">
  <div class="container mx-auto px-4 py-8">
    <div class="flex flex-col md:flex-row md:justify-around md:items-start gap-8">
      <!-- First Column: Logo and Name with Copyright -->
      <div class="flex flex-col">
        <div class="flex items-start space-x-3">
          <img src="/logo.svg" alt="TrishnaWiki Logo" class="w-20 h-20">
          <div class="flex flex-col">
            <app-name size="2xl" weight="bold"></app-name>
            <p class="text-sm text-gray-600">Copyright &copy; {{ currentYear }}</p>
            <p class="text-base text-gray-400 mt-1">Made with Love, from India.</p>
          </div>
        </div>
        <p class="text-sm text-gray-500 pt-5">Version: {{ version }}</p>
      </div>

      <!-- Second Column: Tagline -->
      <div class="flex flex-col justify-center">
        <p class="text-brand-orange font-semibold">Connect, Ask, Preserve.</p>
        <p class="text-gray-700">A platform for preserving the wisdom hidden in lived experiences.</p>
        <p class="text-gray-400 mt-1">Free to use, always. Because wisdom should be shared, not sold.</p>
        <div class="flex gap-4 pt-6">
          <a routerLink="/terms" class="text-sm text-gray-500 hover:text-brand-orange transition-colors">Terms</a>
          <a routerLink="/privacy" class="text-sm text-gray-500 hover:text-brand-orange transition-colors">Privacy</a>
        </div>
      </div>

      <!-- Third Column: Links -->
      <div class="flex flex-col space-y-2 md:items-end">
        <a routerLink="/about" class="text-gray-700 hover:text-brand-orange transition-colors">About</a>
        <a routerLink="/questions" class="text-gray-700 hover:text-brand-orange transition-colors">Questions</a>
        <a routerLink="/team" class="text-gray-700 hover:text-brand-orange transition-colors">Team</a>
        <a routerLink="/contact" class="text-gray-700 hover:text-brand-orange transition-colors">Contact</a>
      </div>
    </div>
  </div>
</footer>
